import styled from '@emotion/styled'

export default styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    width: 75%;
  }

  p {
    line-height: 34px;
    margin: 1rem 0 4rem;
  }
`